import { CourseUrl, SemesterId } from '/imports/domain';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';

export const enrollBaseRoute = lit('enroll');

export const enrollSubRoute = url(type('semester', SemesterId), type('courseUrl', CourseUrl), end);
export const enrollRoute = url(enrollBaseRoute, enrollSubRoute);

export const enrolLink = formatRoute(enrollRoute);
